module.exports = __webpack_public_path__ + "35d4dc0a0184c5c7317e738793578a6f.jpg";